export default __webpack_public_path__ + "static/react-977425aa0f612ce3e792455b174961ed.svg";